import type {
    ComponentStageData,
    InnerElementStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {resetStyleScaling, resetInnerElementStyleScaling} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'
import {getStylePointer} from '../../conversionDal/utils/pointer'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const resetComponentScaling = (componentStageData: ComponentStageData) => {
        const {componentPointer, initialSnapshot} = componentStageData

        if (!initialSnapshot.getValue(getStylePointer(componentPointer))) {
            return
        }

        resetStyleScaling(componentStageData)

        return {
            appliedHeuristics: ['RESET SPX SCALING']
        }
    }

    const resetInnerElementScaling = (innerElementStageData: InnerElementStageData) => {
        const {innerElementPointer, initialSnapshot} = innerElementStageData

        if (!initialSnapshot.getValue(getStylePointer(innerElementPointer))) {
            return
        }

        resetInnerElementStyleScaling(innerElementStageData)

        return {
            appliedHeuristics: ['RESET INNER ELEMENT SPX SCALING']
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(resetComponentScaling))
        registry.registerInnerElementHandler(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(resetInnerElementScaling))
    }

    const name = 'resetStyleScaling'
    return {register, name, dependencies: []}
}
